export const globalTheme = {
  palette: {
    primary: {
      main: '#60B0E3',
    },
    background: {
      default: '#F2F5FF',
    },
    'background.1': {
      light: '#60B0E3',
    },
    'background.2': {
      light: '#9AA5EA',
    },
    'background.3': {
      light: '#B8CACD',
    },
    'background.4': {
      light: '#EBC1B7',
    },
    text: {
      secondary: '#A2ADC3',
    },
    'orange.1': {
      light: '#FFB280',
    },
  },
  typography: {
    body1: {
      fontSize: '14px',
      fontFamily: 'Open Sans',
      fontWeight: 500,
    },
    h1: {
      fontSize: '34.18px',
      fontFamily: 'Open Sans',
      fontWeight: 700,
    },
    h2: {
      fontSize: '27.34px',
      fontFamily: 'Open Sans',
      fontWeight: 700,
    },
    h3: {
      fontSize: '21.88px',
      fontFamily: 'Open Sans',
      fontWeight: 700,
    },
    h4: {
      fontSize: '17.5px',
      fontFamily: 'Open Sans',
      fontWeight: 700,
    },
    body2: {
      fontSize: '11.2px',
      fontFamily: 'Open Sans',
      fontWeight: 500,
    },
  },
}
